"use client";

import { useEffect } from "react";

type Payload = Record<string, unknown>;

export function reportClientError(payload: Payload) {
  try {
    const body = JSON.stringify({
      ...payload,
      url: typeof location !== "undefined" ? location.href : null,
      ua: typeof navigator !== "undefined" ? navigator.userAgent : null,
      ts: new Date().toISOString(),
    });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon("/clog", new Blob([body], { type: "application/json" }));
    } else {
      fetch("/clog", {
        method: "POST",
        body,
        headers: { "Content-Type": "application/json" },
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* jangan pernah bikin error baru dari reporter */
  }
}

// Tangkap error yang LOLOS dari React error boundary.
export function ClientErrorReporter() {
  useEffect(() => {
    const onErr = (e: ErrorEvent) =>
      reportClientError({
        kind: "window.error",
        message: e.message,
        stack: (e.error as Error | undefined)?.stack ?? null,
        source: e.filename,
        line: e.lineno,
        col: e.colno,
      });
    const onRej = (e: PromiseRejectionEvent) => {
      const r = e.reason as { message?: string; stack?: string } | undefined;
      reportClientError({
        kind: "unhandledrejection",
        message: r?.message ?? String(e.reason),
        stack: r?.stack ?? null,
      });
    };
    window.addEventListener("error", onErr);
    window.addEventListener("unhandledrejection", onRej);
    return () => {
      window.removeEventListener("error", onErr);
      window.removeEventListener("unhandledrejection", onRej);
    };
  }, []);
  return null;
}
